import type { BookingConfirmationSummary } from '@massilia/queries'

import { AlertTriangle } from 'lucide-react'

import { shouldShowWeekendBanner } from '@/utils/weekend-alert'

interface WeekendBookingBannerProps {
  summary?: BookingConfirmationSummary
}

export function WeekendBookingBanner({ summary }: WeekendBookingBannerProps) {
  if (!summary || !shouldShowWeekendBanner(summary)) return null

  return (
    <div className="flex gap-3 rounded-2xl border border-red-300 bg-red-50 p-6">
      <AlertTriangle className="mt-0.5 size-5 shrink-0 text-red-600" />
      <div className="flex flex-col gap-1">
        <p className="text-sm font-semibold text-red-800">Votre offre est un tarif promotionnel.</p>
        <p className="text-sm text-red-700">
          Vous devez verser un acompte tout de suite pour conserver votre réservation. Contacter
          l&apos;agence au <span className="font-semibold">04 91 91 06 98</span> en cas de soucis.
        </p>
      </div>
    </div>
  )
}
